import React from "react";
import moment from "moment";
import { Table } from "antd";
import { LinkOutlined } from "@ant-design/icons";

const AdminJobList = (props) => {
  const columns = [
    { title: "Job", dataIndex: ["title"] },
    { title: "Status/Progress", dataIndex: ["status"] },
    {
      title: "Launched At",
      dataIndex: "createdAt",
      render: (createdAt) => (createdAt ? moment(createdAt).fromNow() : "-"),
    },
    {
      title: "Last Progress At",
      dataIndex: "updatedAt",
      render: (updatedAt) => (updatedAt ? moment(updatedAt).fromNow() : "-"),
    },
    {
      title: "Result",
      dataIndex: "link",
      render: (link) =>
        link ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            <LinkOutlined />
          </a>
        ) : (
          "-"
        ),
    },
  ];

  return (
    <div className="table">
      <Table
        rowKey="objectId"
        className="table-section"
        columns={columns}
        dataSource={props.adminJobs}
        pagination={false}
        scroll={{ x: true }}
      />
    </div>
  );
};

export default AdminJobList;
